<template>
  <div>
    <header-section icon="" title="Cuenta bancaria">
      <template slot="buttons">
        <el-button
          size="medium"
          type="danger"
          icon="el-icon-arrow-left"
          @click="$router.push('/inicio')"
        >
          Regresar
        </el-button>
      </template>
    </header-section>

    <div style="text-align: center">
      <div v-if="isSalvadorProgram()">
      <div v-if="!myBankAccount">
				<p>
					Estimado becario su cuenta bancaria se encuentra en proceso de generación.
				</p>
			</div>


			<div v-if="myBankAccount && infoPerson">
				<p>
					Nombre del beneficiario: {{infoPerson.full_name }}
				</p>
				<p>
					Tú cuenta bancaria del banco: {{ myBankAccount.cat_bank.name }}
				</p>

				<p>
					Número de cuenta: {{ myBankAccount.numberAccount }}
				</p>


			</div>
      </div>
      <div v-if="isHondurasProgram()">
      <p>Nombre del beneficiario: {{ infoPerson.full_name }}</p>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-card style="background-color:#0b231e;">
                    <a target="_blank"
                       href="https://jovenesconstruyendoelfuturohn.sre.gob.mx/pdf-file/PASOS_DE_REGISTRO_APP_TENGO.pdf">
                        <font style="color:#fff">
                            Pasos de registro App TENGO
                        </font>
                    </a>
                <br>
                <br />
                    <a target="_blank"
                       href="https://jovenesconstruyendoelfuturohn.sre.gob.mx/video/REGISTRO_BILLETERA_MOVIL_TENGO.mp4">
                        <font style="color:#fff">
                            Video del proceso de registro App TENGO
                        </font>
                    </a>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-form
            label-position="top"
            status-icon
            :model="form"
            label-width="120px"
            id="form"
            :prop="form"
            ref="form"
            @submit.native.prevent
          >
            <el-row type="flex" justify="space-around" :gutter="10">
              <el-col :span="12">
                <el-form-item
                  label="Teléfono Móvil"
                  prop="mobile_phone"
                  :rules="[
                    {
                      required: true,
                      message: 'El campo es requerido',
                      trigger: ['blur', 'change'],
                    },
                    {
                      required:true,
                      max:8,
                      message: 'El número móvil debe ser de 8 digitos',
                      trigger: ['blur', 'change'],
                    },
                  ]"
                >
                  <el-input
                    v-my-only-alphanumeric
                    placeholder="Teléfono Móvil"
                    maxlength="8"
                    v-model="form.mobile_phone"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" justify="space-around" :gutter="10">
              <el-col :span="12">
                <el-form-item
                  label="¿Cuentas con billetera móvil TENGO?"
                  prop="has_mobile_wallet"
                >
                  <el-switch
                    v-model="form.has_mobile_wallet"
                    active-text="Si"
                    inactive-text="No"
                    :active-value="1"
                    :inactive-value="0"
                    active-color="#13ce66"
                  >
                  </el-switch>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="form.has_mobile_wallet != 1" type="flex" justify="space-around" :gutter="10">
              <el-col :span="8">
                <el-form-item label="¿Tienes smartphone?" prop="has_smartphone">
                  <el-switch
                    v-model="form.has_smartphone"
                    active-text="Si"
                    inactive-text="No"
                    active-color="#13ce66"
                    :active-value="1"
                    :inactive-value="0"
                  >
                  </el-switch>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
      </el-row>
      <el-row>
        <el-col align="end">
          <el-button type="success" style="width: 250px" @click="submitForm"
            >Actualizar
          </el-button>
        </el-col>
      </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import programMixin from "@/mixins/programMixin";

const HeaderSection = (_) =>
  import(
    /* webpackChunkName: "js/split/HeaderSection" */ "@/components/partials/HeaderSection"
  );

import Phone from "@/components/views/home/young/register/partials/Phone";

export default {
  components: {
    HeaderSection,
    Phone,
  },
  mixins:[programMixin],
  computed: {
    ...mapGetters("young", {
      infoPerson: "person",
    }),
    myBankAccount() {
      return this.infoPerson && this.infoPerson.my_bank_account
        ? this.infoPerson.my_bank_account
        : null;
    },
  },
  watch: {
    infoPerson: function () {
      this.getDataMobileWallet();
    },
  },
  methods: {
    ...mapActions("young", {
      fetchSigle: "fetchSigle",
    }),
    iniOnlyProfile() {
      return this.fetchSigle()
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {});
    },
    requestChange() {
      console.log("requestChange");
    },
    getDataMobileWallet() {

      let params = {
        hash_id: this.infoPerson.hash_id,
      };
      let url = "/api/get-mobile-wallet";
      return axios
        .get(`${url}`, { params: params })
        .then((res) => {
          this.loading_responsible = false;
          this.form.mobile_phone = res.data.mobile_wallet.mobile_phone;
          this.form.has_mobile_wallet =
            res.data.mobile_wallet.has_mobile_wallet;
          this.form.has_smartphone = res.data.mobile_wallet.has_smartphone;
        })
        .catch((err) => {
          this.loading_responsible = false;
        });
    },
    submitForm() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.$store.dispatch('loading/spinner', {msg: 'Guardando información...', status: true}, {root: true});

          axios
            .post("/api/save-mobile-wallet", this.form)
            .then((response) => {

              this.$message({
                type: "success",
                title: "Éxito",
                message: "Se almacenó la información correctamente",
              });

              //this.$router.push("/inicio");
            })
            .catch((error) => {

              this.$message({
                type: "warning",
                message:
                  "No fue posible completar la acción, intente nuevamente.",
              });
            }).finally(()=>this.$store.dispatch('loading/spinner', {}, {root: true}));
        } else {
          this.$message({
            type: "error",
            message: "Necesitas completar los campos",
          });
        }
      });
    },
  },
  created() {
    this.iniOnlyProfile();
  },
  data() {
    return {
      form: {
        mobile_phone: null,
        has_mobile_wallet: null,
        has_smartphone: null,
      },
    };
  },
};
</script>

<style scoped>
</style>
